import { Link, Outlet, useNavigate } from 'react-router-dom';
import Page from '../../components/PageWrapper';

function ReconciliationsOutlet() {

  return (
    <Page title="Reconciliations">
      <Outlet />
    </Page>
  );
}

export default ReconciliationsOutlet;
